export const EMPIRE_CODE_PLACEHOLDER = "SKU Number";
export const SKU_SHORT_DESCRIPTION = "SKU Short Desc.";
export const SKU_NAME = "SKU Name";
export const SKU_LONG_DESCRIPTION = "SKU Description";
export const CFO_APPROVAL = "CFO Approval";
export const NO_CFO_APPROVAL = "No CFO approval";
export const COST_CATEGORY = "Cost Type";
export const COST_CATEGORY_PLACEHOLDER = "Select Cost Type";
export const CHARGING_INCREMENT = "Charging Increment";
export const CHARGING_INCREMENT_PLACEHOLDER = "Select Charging Increment";
export const COST_INTERVAL = "Cost Interval";
export const COST_INTERVAL_PLACEHOLDER = "Select Cost Interval";
export const RETURNABLE = "Returnable";
export const RETURNABLE_PLACEHOLDER = "Select Returnable";
export const COST_MACRO_CATEGORY = "Types of Cost Included";
export const COST_MACRO_CATEGORY_PLACEHOLDER = "Select Types of Cost Included";
export const MINIMUM_SELECTABLE_INCREMENT = "Minimum Selectable Increment";
export const COST = "Cost Basis";
export const COST_PLACEHOLDER = "In USD$";
export const SKU_RELATION = "SKU Relation";
export const SKU_RELATION_PLACEHOLDER = "Select SKU Relation";
export const AUTO_PROVISION = "Auto Provision";
export const AUTO_PROVISION_PLACEHOLDER = "Select Auto Provision";
export const COMMERCIAL_STATUS = "Status";
export const BILLING_TYPE_STATUS = "Billing Type";
export const COMMERCIAL_PLACEHOLDER = "Status";
export const COST_METRIC = "Cost Metric";
export const COST_METRIC_PLACEHOLDER = "Select Cost Metric";
export const NSR = "NSR";
export const INDEXATION = "Indexation";
export const INDEXATION_PLACEHOLDER = "In percentage %";
export const COST_BASIS_PLACEHOLDER = "In USD$";
export const OLD_COST_BASIS = "Old Cost Basis";
export const OLD_INDEXATION = "Old Indexation";
export const OLD_NSR = "Old NSR";
export const OLD_COST_PUBLISH_DATE = "Old Cost Publish Date";
export const REQUEST_COST_CHANGE = "Request Cost Change";

export const NEW_COSTING = "New Costing";
export const NEW_COST_BASIS = "New Cost Basis";
export const NEW_INDEXATION = "New Indexation";
export const NEW_NSR = "New NSR";
export const NEW_COST_PUBLISH_DATE = "New Cost Publish Date";
export const CANCEL = "Cancel";
export const SUBMIT_FOR_APPROVAL = "Submit for Approval";
export const CANCEL_FOR_APPROVAL = "Yes, Cancel Request";
export const CANCEL_UPDATE_REQUEST = "Cancel Update Request";

export const configSkuResponse = {
  Status: "success",
  Message: "Get SKU Config Details successfully",
  Data: {
    CommercialStatus: [
      {
        StatusCd: "prod_active",
        StatusType: "prod",
        Name: "Active",
      },
      {
        StatusCd: "prod_draft",
        StatusType: "prod",
        Name: "Draft",
      },
      {
        StatusCd: "prod_inactive",
        StatusType: "prod",
        Name: "InActive",
      },
      {
        StatusCd: "sku_activecntrybilled",
        StatusType: "sku",
        Name: "Active w Country Billing",
      },
      {
        StatusCd: "sku_activeengbilled",
        StatusType: "sku",
        Name: "Active w Engagement Billing",
      },
      {
        StatusCd: "sku_activenotbilled",
        StatusType: "sku",
        Name: "Active but not Billed",
      },
      {
        StatusCd: "sku_draft",
        StatusType: "sku",
        Name: "Draft",
      },
      {
        StatusCd: "sku_retired",
        StatusType: "sku",
        Name: "Retired",
      },
      {
        StatusCd: "sku_retiring",
        StatusType: "sku",
        Name: "Retiring",
      },
    ],
    CostCategory: [
      {
        CostMetricCd: "fix_cost",
        Name: "Fixed Cost",
      },
      {
        CostMetricCd: "fix_hrs",
        Name: "Fixed Cost (hrs)",
      },
      {
        CostMetricCd: "fix_license",
        Name: "Fixed Cost (licenses)",
      },
    ],
    CostMacroCategory: [
      {
        CostMacroCategoryCd: "equityrecovery",
        Name: "Equity recovery",
      },
      {
        CostMacroCategoryCd: "invest",
        Name: "Invest",
      },
      {
        CostMacroCategoryCd: "operate",
        Name: "Operate",
      },
    ],
    ChargingIncrement: [
      {
        CostIntervalCd: "month",
        Name: "Monthly",
      },
      {
        CostIntervalCd: "onetime",
        Name: "One Time",
      },
      {
        CostIntervalCd: "week",
        Name: "Weekly",
      },
    ],
  },
  TimeStamp: "2025-04-10T09:20:34.059Z",
};
export const ORDER_ACKNOWLEDGEMENT = "Order acknowledgment";
export const GLOBAL_RISK_MANAGER = "Global Risk Manager";
export const GLOBAL_RISK_MANAGER_FIELD = "global_risk_manager";
export const LOCAL_RISK_MANAGER = "Local Risk Manager";
export const PRODUCT_APPROVER = "Product Approver";
export const PROVISIONING_TEAM = "Provisioning Team";
export const PREVENT_SKU_SUBMISSION =
  "You can Save as Draft, once you completed the pending product fields, you will be able to Submit your SKU.";
export const MISSING_FIELDS_ERROR =
  "Please complete the Product fields to submit an SKU for approval.";
export const SKU_CREATION_MESSAGE =
  "You can save the SKU data as a Draft while you complete the product missing fields.";
